import { Component, Input, OnChanges, inject } from "@angular/core";
import { TicketAuditViewerComponent } from "@app/view/shared/audits/ticket-audit-viewer/ticket-audit-viewer.component";
import { ResourceAvailabilityAuditViewerComponent } from "@app/view/shared/audits/resource-availability-audit-viewer/resource-availability-audit-viewer.component";
import { MatDialog } from "@angular/material/dialog";
import { VisitAuditViewerComponent } from "@app/view/shared/audits/visit-audit-viewer/visit-audit-viewer.component";
import { MatButton } from "@angular/material/button";

@Component({
  selector: "app-audit-jump-button",
  templateUrl: "./audit-jump-button.component.html",
  styleUrls: ["./audit-jump-button.component.css"],
  imports: [MatButton]
})
export class AuditJumpButtonComponent implements OnChanges {
  protected dialog = inject(MatDialog);

  @Input() linkString: string;
  linkEnabled: boolean;
  linkType: string;
  linkId: number;
  supportedLinkTypes = ["...Ticket", "...Visit", "...ResourceAvailability"];

  ngOnChanges() {
    //parse the link string of format ...ResourceAvailability/12345
    let linkParts = this.linkString.split("/");
    this.linkId = parseInt(linkParts[linkParts.length - 1]);
    this.linkType = linkParts[linkParts.length - 2];

    this.linkEnabled = !this.supportedLinkTypes.includes(this.linkType);
  }

  openAudit() {
    switch (this.linkType) {
      case "...Ticket":
        this.openTicketAudit();
        break;
      case "...ResourceAvailability":
        this.openResourceAvailabilityAudit();
        break;
      case "...Visit":
        this.openVisitAudit();
        break;
    }
  }

  openTicketAudit() {
    this.dialog.open(TicketAuditViewerComponent, {
      width: "calc(100vw - 100px)",
      data: {
        ticketId: this.linkId
      }
    });
  }

  openResourceAvailabilityAudit() {
    this.dialog.open(ResourceAvailabilityAuditViewerComponent, {
      width: "calc(100vw - 100px)",
      data: {
        availabilityId: this.linkId
      }
    });
  }

  openVisitAudit() {
    this.dialog.open(VisitAuditViewerComponent, {
      width: "calc(100vw - 100px)",
      data: {
        visitId: this.linkId
      }
    });
  }
}
